/**
 * Wall Art Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Wall Art
 * template.
 *
 * @namespace wallArt
 */

theme.wallArt = (() => {
  const mobileBreakpoint = 995;
  const initialWindowWidth = window.innerWidth;
  const initialWindowHeight = window.innerHeight;

  function changeWindowSize(initialWindowWidth, initialWindowHeight) {
    const windowWidthDifference = (window.innerWidth - initialWindowWidth);
    const windowHeightDifference = (window.innerHeight - initialWindowHeight);
    const distancePositive = 120;
    const distanceNegative = -120;
    if (windowWidthDifference >= distancePositive || windowWidthDifference <= distanceNegative) {
      return true;
    } else if (windowHeightDifference >= distancePositive || windowHeightDifference <= distanceNegative) {
      return true;
    }
    return false;
  }

  function setHeroHeight() {

    if ($('.page-category-wall-art') && window.innerWidth <= mobileBreakpoint) {
      // calculate min-height on init in order for the cta to be aligned to bottom of window
      $(".js-hero-wall-art").css("height", `${initialWindowHeight}px`);
      // recalculate the min-height everytime the address bar appears or disappears
    }
  }

  function init() {
    if ($('.page-category-wall-art') && window.innerWidth <= mobileBreakpoint) {
      setHeroHeight();
      $(window).resize(() => {
        if (changeWindowSize(initialWindowWidth, initialWindowHeight)) {
          setHeroHeight();
        }
      });
    }
  }

  return {
    init: init
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/templates/wall-art.js